export default "__VITE_ASSET__BHzU3x4v__"